<template>
  <div class="flex md:justify-end items-center px-5 md:px-0 mt-4">
    <span class="mr-4 whitespace-nowrap">
      {{ $t('Sort by') }} :
    </span>
    <CustomSelect
      v-model="sortOption"
      class="md:w-auto w-full"
      name="sort-reviews"
      @input="sortReviews"
    >
      <template #label>
        <div class="sr-only">
          {{ $t('Sort reviews') }}
        </div>
      </template>
      <SelectOption
        v-for="sortOption in localizedSortingOptions"
        :key="sortOption.value"
        :value="sortOption.value"
      >
        {{ sortOption.name }}
      </SelectOption>
    </CustomSelect>
  </div>
</template>
<script lang="ts">

import { REVIEW_SORTING_OPTIONS } from '~~/constants/reviewSortingOptions';

import getSortParamsFromString from '~~/helpers/getSortParamsFromString';
import {
  DEFAULT_REVIEWS_SEARCH_PARAMS,
  PAGINATION_DEFAULT_RESULTS_LIMIT,
} from '~~/constants/pagination';

export default defineComponent({
  name: 'SortingReviews',

  props: {
    totalResultsAmount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: PAGINATION_DEFAULT_RESULTS_LIMIT,
    },
    productId: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const productIdRef = toRef(props, 'productId');

    const {
      search: searchReviews,
      updateSortParams,
    } = useReviewExtended(productIdRef);

    const {
      resetPaginationPage,
    } = usePagination(props.totalResultsAmount, props.perPage);

    const i18n = useI18n();

    const localizedSortingOptions = computed(() => {

      return REVIEW_SORTING_OPTIONS.map((option) => {

        return {
          value: option.value,
          name: i18n.t(option.name),
        };
      
      });
    
    });

    const sortOption = ref(localizedSortingOptions.value[0].value);

    const sortReviews = () => {

      const sort = getSortParamsFromString(sortOption.value);
      updateSortParams(sort);
      const paginationParams = {
        offset: DEFAULT_REVIEWS_SEARCH_PARAMS.offset,
        limit: DEFAULT_REVIEWS_SEARCH_PARAMS.limit,
      };
      resetPaginationPage();
      searchReviews(paginationParams);
    
    };

    return {
      sortReviews,
      sortOption,
      REVIEW_SORTING_OPTIONS,
      localizedSortingOptions,
    };
  
  },
});

</script>
<style lang="scss" scoped>
  :deep(.ex-select) {
    --sort-select-height: 3rem;

    min-height: auto;
    height: var(--sort-select-height);
  }
</style>
